import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { firestorePlugin } from "vuefire";
import { firebaseApp } from "./database/db";
import Toasted from "vue-toasted";

Vue.config.productionTip = false;

Vue.use(firestorePlugin);
Vue.use(Toasted);

let app;

firebaseApp.auth().onAuthStateChanged((user) => {
  if (user) {
    console.log("user", user, user.email);
  } else {
    console.log("nouser");
  }

  if (!app) {
    console.log("creating app");
    app = new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  }
});

// new Vue({
//   router,
//   store,
//   render: (h) => h(App),
// }).$mount("#app");
